import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from './LoginForm';
import '../pages/Auth/AuthPages.css';

export default function LoginModal({ onLoggedIn, onClose }) {
  return (
    <div className="auth-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="auth-modal-card auth-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="auth-modal-head">
          <h1 id="auth-modal-title">Sign in</h1>
          <button type="button" className="auth-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <p className="auth-card__lead">Use the account an administrator has approved.</p>
        <LoginForm
          inputIdPrefix="login-modal"
          onLoggedIn={onLoggedIn}
          extraActions={
            <>
              <button type="button" className="auth-modal-link-btn" onClick={onClose}>
                Cancel
              </button>
              <Link to="/forgot-password" onClick={onClose}>
                Forgot password?
              </Link>
              <Link to="/register" onClick={onClose}>
                Request access (register)
              </Link>
            </>
          }
        />
      </div>
    </div>
  );
}
